<template>
	<span class="theme-color-4">{{ currentTime }}</span>
</template>

<style scoped>
span {
  display: block;
  font-size: 13px;
  /* color: #636363; */
  text-align: center;
  font-weight: 300;
}

</style>

<script>

	export default {

		data() {
			return {
				currentTime:'',
				timer:null,
			}
		},
		methods:{
			updateTime(){
				var date = new Date();
				this.currentTime =
				('0'+date.getHours()).substr(-2,2)
				+'h '+
				('0'+date.getMinutes()).substr(-2,2)
				+'m'
				this.timer = setTimeout(()=>{ this.updateTime() },1000*1);
			}
		},
		activated(){
			clearTimeout(this.timer);
			this.updateTime();
		}
	}

</script>